export default {
    findRoles:      { method: 'get', url: 'roles?with=menus'},
    featureCatalog: { method: 'get', url: 'role-features/catalog'},
    roleUsers:      { method: 'get',  url: 'roles/{id}/users'},
    searchUsers:    { method: 'get',  url: 'users/institution'},
    attachUserRole: { method: 'post', url: 'user_roles'},
    revokeUserRole: { method: 'post', url: 'user_roles/revoke'},
    createRole:     { method: 'post', url: 'roles'},
    updateRole:     { method: 'put', url: 'roles/{id}'},
    updateRoleMenu: { method: 'put', url: 'roles/menu/{id}'},
    instances:      { method: 'get', url: 'instances?column_order=name'},
    charts:         { method: 'get', url: 'roles/charts' },
    index:          { method: 'get', url: 'roles?with=features|menus|permissions|charts'},
    destroyRole:    { method: 'delete', url: 'roles/{id}'}
}